import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkPlanLimit, clearCouponCodeStatus, downgradePlan, getEstimationDetails, getPlansList, resetResponseStatus, setShowEstimationScreen, upgradePlan } from "../../../store/menu/pricing/actions"
import BackButton from '../../../assets/images/lystfacelogos/BackButton.svg';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, FormFeedback, Input, Label, Spinner } from "reactstrap";
import { headerDropdownIcon, LockIcon } from "../../../components/Common/SvgIcons";
import PasswordToolTip from "../../../components/Common/PasswordToolTip";
import { lime } from "@material-ui/core/colors";
import { CustomToast } from "../../../components/Lystface/Common/CustomToast";
import { addPlan, getCardList, resetPlanResponse } from "../../../store/actions";
import { LystfacePayMethIntent } from "../../../helpers/lystface_helper";
import { useStripe } from "@stripe/react-stripe-js";
import { getPlanSpecificationDetails } from "../../../store/menu/home/actions";
import CrossIcon from '../../../assets/images/lystfacelogos/CrossIcon.svg';
import { isNotNullOrUndefined } from "../../../common/functions";


const EstimationScreen = ({ planList, currenPlanId }) => {
    const dispatch = useDispatch();
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [couponCode, setCouponCode] = useState("")
    const PricingState = useSelector(state => state.Pricing)
    const {
        planId: selectedPlanId,
        type,
        active_trial,
        estimationScreenDetails: { loading: EstimationDetailsLoading, couponLoading: couponLoading, response: EstimationDetails, responseCode: EstimationResponseCode, responseMessage: EstimationResponseMessage },
        upgradePlan: { loading: upgradePlanLoading, responseCode: upgradePlanResponseCode, responseMessage: upgradePlanResponseMessage },
        downgradePlan: { loading: downgradePlanLoading, responseCode: downgradePlanResponseCode, responseMessage: downgradePlanResponseMessage },
        planLimit: { response: planLimitDetails }

    } = PricingState
    const defaultplan = planList.find(obj => obj?.planId === parseInt(selectedPlanId))
    const [selectedPlan, setSelectedPlan] = useState(defaultplan)
    const PlanUserState = useSelector(state => state.Plan)
    const { planAddLoading, repMessage, planAdded, externalPlanId } = PlanUserState
    const BillSetState = useSelector(state => state.BillSet)
    const { cardList } = BillSetState
    const defaultCardId = cardList?.list?.find(obj => obj.default)?.id
    const stripe = useStripe();
    const [stripeDetails, setStripeDetails] = useState({ loading: "hello", message: null })
    const [loading, setLoading] = useState(false)
    const [appliedCoupon, setAppliedCoupon] = useState(false)
    const [couponCodefordisplay, setCouponCodeForDisplay] = useState("")


    useEffect(() => {
        return () => {
            dispatch(clearCouponCodeStatus({}))

        }
    }, [])


    useEffect(() => {
        setCouponCode("")
        setAppliedCoupon(false)
        dispatch(getEstimationDetails({ plan: selectedPlan?.planId?.toString(), process: type }))
        dispatch(getCardList())
        if (currenPlanId > selectedPlan?.planId) {
            dispatch(checkPlanLimit({ plan: selectedPlan?.planId?.toString() }))
        }

    }, [selectedPlan?.planId])

    useEffect(() => {
        if (isNotNullOrUndefined(EstimationDetails?.couponValid)) {
            setAppliedCoupon(true)

        }
        if (isNotNullOrUndefined(EstimationDetails?.couponValid) && couponCode?.length === 0) {
            handleClearCoupon();
        }
    }, [EstimationDetails?.couponValid, couponCode])








    useEffect(() => {

        if (upgradePlanResponseMessage || downgradePlanResponseMessage || (repMessage && externalPlanId) || stripeDetails?.message || EstimationResponseMessage && !EstimationResponseCode) {
            CustomToast({
                message: upgradePlanResponseMessage || downgradePlanResponseMessage || repMessage || stripeDetails?.message || EstimationResponseMessage,
                status: upgradePlanResponseCode || downgradePlanResponseCode || planAdded ? "success" : 'failure',
                time: (downgradePlanResponseMessage && downgradePlanResponseCode) ? 8000 : null,
                closeToast: () => {
                    console.log('Toast closed');
                },
            })
            if (planAdded) {
                dispatch(getPlanSpecificationDetails())
                dispatch(getPlansList({}))


            }
            if (downgradePlanResponseMessage && downgradePlanResponseCode) {
                dispatch(getPlansList({}))

            }
            dispatch(resetResponseStatus({ from: EstimationResponseMessage && !EstimationResponseCode ? "estimation" : "" }))
            dispatch(resetPlanResponse())
            setStripeDetails({ loading: false, message: null })
        }
        if (upgradePlanResponseCode || downgradePlanResponseCode || planAdded) {
            dispatch(setShowEstimationScreen({ show: false }))

        }



    }, [upgradePlanResponseMessage, downgradePlanResponseMessage, downgradePlanResponseCode, upgradePlanResponseCode, repMessage, planAdded, stripeDetails, EstimationResponseCode, EstimationResponseMessage])


    const onClickBack = () => {
        dispatch(setShowEstimationScreen({ show: false }))

    }
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen)
    }

    const handleChangePlan = (plan) => {
        setSelectedPlan(plan)
    }

    const handleClickPayment = async () => {
        if (type === "upgrade") {
            if (active_trial || EstimationDetails?.grandTotal === "0.00") {
                dispatch(upgradePlan({ plan_id: selectedPlan?.planId.toString(), ...((couponCode?.length > 0 && EstimationDetails?.couponValid) && { coupon: couponCode }) }))

            }
            else {
                setLoading(true)
                let clientSecret;
                const response = await LystfacePayMethIntent({
                    payment_method: defaultCardId,
                    amount: EstimationDetails?.grandTotal
                });

                if (!response.responseCode) {
                    setLoading(false)
                    setStripeDetails({ loading: false, message: response?.responseMessage })
                }
                else {
                    clientSecret = response?.response?.client_secret
                }
                if (clientSecret) {
                    const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
                        payment_method: defaultCardId,
                    });

                    if (confirmError) {
                        setLoading(false)
                        setStripeDetails({ loading: false, message: confirmError?.message })
                        console.log(confirmError?.message);
                    } else {
                        if (paymentIntent.status === 'requires_action') {
                            window.location.href = paymentIntent.next_action.redirect_to_url.url;
                        } else if (paymentIntent.status === 'succeeded') {
                            setLoading(false)
                            dispatch(upgradePlan({ plan_id: selectedPlan?.planId.toString(), ...((couponCode?.length > 0 && EstimationDetails?.couponValid) && { coupon: couponCode }) }))

                        }
                    }
                }
            }


        }
        else {
            if (currenPlanId) {
                dispatch(downgradePlan({ plan_id: selectedPlan?.planId.toString(), ...((couponCode?.length > 0 && EstimationDetails?.couponValid) && { coupon: couponCode }) }))

            }
            else {
                dispatch(addPlan({ plan_id: selectedPlan?.planExtId, process: "resubscribe", ...((couponCode?.length > 0 && EstimationDetails?.couponValid) && { coupon: couponCode }) }, { planId: selectedPlan?.planId }))
            }

        }
    }

    const handleClickApplyCoupon = () => {
        setCouponCodeForDisplay(couponCode)
        if (!EstimationDetailsLoading) {
            dispatch(getEstimationDetails({ plan: selectedPlan?.planId?.toString(), process: type, coupon: couponCode, from: "coupon" }))

        }
    }

    const handleClearCoupon = () => {
        setCouponCode("");
        setAppliedCoupon(false)
        if (EstimationDetails?.couponValid) {
            dispatch(getEstimationDetails({ plan: selectedPlan?.planId?.toString(), process: type, from: "coupon" }))

        }
        dispatch(clearCouponCodeStatus({}))



    }
    return (
        <div className="estimation-screen-container">
            <div className="title-container">
                <div className='back-icon' onClick={onClickBack}>
                    <img src={BackButton} alt="back button" />
                </div>
                <div className="title">
                    Plan estimate {loading}
                </div>

            </div>
            <div className="line-break" />
            {
                (!EstimationDetailsLoading && !EstimationResponseCode) ?

                    <div className="no-data">
                        <span>No data</span>
                    </div>
                    :
                    <div className="plan-details-container">
                        <div className="left-container">
                            <span className="title">Plan details</span>
                            <div className="billing-cycle-container">
                                <span className="title">Billing cycle</span>
                                <span className="cycle">

                                    {(EstimationDetailsLoading && !couponLoading) ?
                                        <div className="skeleton-loader">
                                            <div className="skeleton-box"></div>
                                        </div> :
                                        <>
                                            {EstimationDetails?.billingSt} - {EstimationDetails?.billingEnd}</>

                                    }
                                </span>

                                <Dropdown
                                    isOpen={dropdownOpen}
                                    toggle={toggleDropdown}
                                    className="dropdown-icon"
                                >
                                    <DropdownToggle
                                        className={`dropdown-toggle ${dropdownOpen ? "focused" : ""}`}
                                        id="page-header-user-dropdown"
                                        tag="span"

                                    >
                                        <div>{selectedPlan?.planName} plan</div>
                                        <div className="dropdown-icon">{headerDropdownIcon}</div>
                                    </DropdownToggle>
                                    <DropdownMenu className="payment-dropdown" >
                                        {
                                            planList.map((plan, i) => (
                                                <DropdownItem
                                                    className={`dropdown-item  ${(type === "downgrade" ? plan.planId >= currenPlanId : plan.planId <= currenPlanId) ? "disabled" : ""} ${(plan.planId === selectedPlan?.planId) ? "selected" : ""}`}
                                                    key={plan.planId}
                                                    onClick={() => {
                                                        handleChangePlan(plan);
                                                    }}
                                                    disabled={type === "downgrade" ? plan.planId >= currenPlanId : plan.planId <= currenPlanId}
                                                >

                                                    {plan?.planName} plan

                                                </DropdownItem>
                                            ))
                                        }

                                    </DropdownMenu>
                                </Dropdown>
                                <div className="charge-details-container">
                                    {type == "downgrade" && <div>
                                        Fixed price
                                    </div>}
                                    {
                                        type !== "downgrade" &&
                                        <div className="prorated-charge">
                                            <div className="tooltip-container">
                                                <span>Prorated charge</span>
                                                <PasswordToolTip hideArrow={false} id="prorated" content="Prorated charge for the remaining days of your new plan, calculated from the current billing cycle." />
                                            </div>
                                            <div className="actual-price">
                                                (actual price <span className="bold">
                                                    {
                                                        (EstimationDetailsLoading && !couponLoading) ?
                                                            <div className="skeleton-loader">
                                                                <div className="skeleton-box"></div>
                                                            </div>
                                                            :
                                                            <>${EstimationDetails?.flatRate}</>}</span>)
                                            </div>
                                        </div>
                                    }

                                    <div className="bold">
                                        {(EstimationDetailsLoading && !couponLoading) ?
                                            <div className="skeleton-loader">
                                                <div className="skeleton-box"></div>
                                            </div> :
                                            <>
                                                $ {EstimationDetails?.proratedAmount || EstimationDetails?.flatRate}</>}
                                    </div>


                                </div>
                                <div className="line-break" />




                            </div>
                            <div className={`pending-charges-details-container ${type !== "resubscribe" && !active_trial ? "transanction" : ""}`}>
                                {
                                    (type !== "resubscribe" && !active_trial) &&
                                    <div className="pending-charges-container">
                                        <span className="bold">Pending charges on previous plan</span>
                                        <span >Additional transactions</span>
                                        <div className="charges">
                                            <span>
                                                {(EstimationDetailsLoading && !couponLoading) ?
                                                    <div className="skeleton-loader">
                                                        <div className="skeleton-box"></div>
                                                    </div> :
                                                    <>{EstimationDetails?.transCount}  x {EstimationDetails?.meteredRate}</>
                                                }
                                            </span>
                                            <span className="bold">
                                                {(EstimationDetailsLoading && !couponLoading) ?
                                                    <div className="skeleton-loader">
                                                        <div className="skeleton-box"></div>
                                                    </div> :
                                                    <>
                                                        $ {EstimationDetails?.transAmt}</>} </span>
                                        </div>
                                    </div>

                                }


                                <div className="charges">
                                    <span>Subtotal </span>
                                    <span>
                                        {(EstimationDetailsLoading && !couponLoading) ?
                                            <div className="skeleton-loader">
                                                <div className="skeleton-box"></div>
                                            </div> :
                                            <>
                                                ${EstimationDetails?.subTotal}</>}
                                    </span>
                                </div>
                            </div>

                        </div>
                        <div className="right-container">
                            <div className="title">Overview</div>
                            <div>
                                <div className='form-password-container'>
                                    <Label className="form-input-title">
                                        Have any coupon code?
                                    </Label>
                                    <Input
                                        name="email"
                                        className={`form-input password-input  ${isNotNullOrUndefined(EstimationDetails?.couponValid) ? "non-editable" : ""} ${isNotNullOrUndefined(EstimationDetails?.couponValid) && !EstimationDetails?.couponValid && couponCode.length > 0
                                            ? `border-danger`
                                            : ``
                                            }`}
                                        formNoValidate={true}
                                        type="text"
                                        onChange={(e) => {
                                            setCouponCode(e.target.value);
                                        }}
                                        value={couponCode || ""}
                                        placeholder="Enter promo code"
                                        readOnly={isNotNullOrUndefined(EstimationDetails?.couponValid)}
                                    />
                                    {couponCode &&
                                        <div className="cross-icon">
                                            {!appliedCoupon && <span className={`apply ${couponLoading ? "disabled" : ""}`} onClick={handleClickApplyCoupon}>
                                                Apply
                                                {
                                                    couponLoading &&
                                                    <div className="spinner-container spinner-border">
                                                    </div>
                                                }
                                            </span>}
                                            {(isNotNullOrUndefined(EstimationDetails?.couponValid)) && < span onClick={handleClearCoupon}>
                                                <img src={CrossIcon} />
                                            </span>}
                                        </div>
                                    }


                                </div>
                                {(isNotNullOrUndefined(EstimationDetails?.couponValid) && couponCode.length > 0) &&
                                    <FormFeedback type="invalid" className={`d-block error-message ${EstimationDetails?.couponValid ? "valid" : ""}`}>
                                        {(EstimationDetails?.couponValid) ? "Coupon applied!" : "Invalid code"}
                                    </FormFeedback>
                                }
                            </div>

                            <div className="total">
                                <span>Subtotal</span>
                                <span>
                                    {(EstimationDetailsLoading && !couponLoading) ?
                                        <div className="skeleton-loader">
                                            <div className="skeleton-box"></div>
                                        </div> :
                                        <>
                                            $ {EstimationDetails?.subTotal} </>}
                                </span>
                            </div>
                            {(EstimationDetails?.discount) &&
                                <div className="total">
                                    <span>{`Coupon (${couponCodefordisplay})`}</span>

                                    <span className="credit">
                                        {EstimationDetailsLoading ?
                                            <div className="skeleton-loader">
                                                <div className="skeleton-box"></div>
                                            </div> :
                                            <>
                                                - $ {EstimationDetails?.discount}</>}
                                    </span>
                                </div>
                            }
                            {(type === "upgrade" && !active_trial) &&
                                <div className="total">
                                    <div className="tooltip-container">
                                        <span>Credit</span>
                                        <PasswordToolTip hideArrow={false} id="credit" content="Credit is the remaining balance from your current plan, which will be applied towards your new plan." />
                                    </div>

                                    <span className="credit">
                                        {EstimationDetailsLoading ?
                                            <div className="skeleton-loader">
                                                <div className="skeleton-box"></div>
                                            </div> :
                                            <>
                                                - $ {EstimationDetails?.credit}</>}
                                    </span>
                                </div>
                            }


                            <div className="line-break" />

                            <div className="total grand">
                                <span>Grand total</span>
                                <span>
                                    {EstimationDetailsLoading || couponLoading ?
                                        <div className="skeleton-loader">
                                            <div className="skeleton-box"></div>
                                        </div> :
                                        <>
                                            $ {EstimationDetails?.grandTotal}</>}
                                </span>
                            </div>
                            {type === "downgrade" &&
                                <div className="note-message">
                                    <span className="message">
                                        Your changes will take effect in the next billing cycle. Please note, the number of transactions may vary based on your usage.
                                    </span>
                                </div>
                            }

                            <button className={`btn-save ${(upgradePlanLoading || downgradePlanLoading || planAddLoading || loading || (planLimitDetails?.overallCheck === 0 && type === "downgrade") || couponLoading) ? "button-disabled" : ""}`} onClick={handleClickPayment}
                                disabled={upgradePlanLoading || downgradePlanLoading || planAddLoading || loading || (planLimitDetails?.overallCheck === 0 && type === "downgrade") || couponLoading}
                            >
                                {(type !== "downgrade" && !active_trial && EstimationDetails?.grandTotal !== "0.00") && <div className="lock-icon">{LockIcon}</div>}
                                {(type !== "downgrade" && !active_trial && EstimationDetails?.grandTotal !== "0.00") ? "Pay now" : "Subscribe"}
                                {(upgradePlanLoading || downgradePlanLoading || planAddLoading || loading) &&
                                    <div className="spinner-container spinner-border">
                                    </div>
                                }

                            </button>
                        </div>
                    </div>
            }

        </div >
    )

}
export default EstimationScreen